import withAuth from "@auth/withAuth";
import { Button, DatePicker, Flex } from "@components/index";
import { useReport } from "@services/report/hooks";
import { isDateAfterTodayOrBeforeJuneOfLastYear } from "@src/module/utils/datetime";
import { useState } from "react";
import styles from "./ManagementReport.module.scss";

const ManagementReport: React.FC = () => {
  const [startDate, setStartDate] = useState<Date>(null);
  const [endDate, setEndDate] = useState<Date>(null);

  const { getReport } = useReport();

  const hasInvalidDateRange =
    startDate &&
    endDate &&
    new Date(endDate).getTime() < new Date(startDate).getTime();

  const handleGenerateReport = () => {
    if (hasInvalidDateRange) return;

    void getReport(startDate, endDate);
  };

  return (
    <form className={styles.form}>
      <h1 className="text text--xl text--neutral--600 pb-50">
        Relatório Gerencial
      </h1>

      <Flex.Row
        flexWrap="nowrap"
        alignItems="center"
        alignContent="center"
        justifyContent="space-between"
        justifyItems="center"
        gap="10px"
      >
        <DatePicker
          id="startDate"
          label="Data Inicial"
          size="lg"
          value={startDate}
          onChange={setStartDate}
          shouldDisableDate={isDateAfterTodayOrBeforeJuneOfLastYear}
        />

        <DatePicker
          id="endDate"
          label="Data Final"
          size="lg"
          value={endDate}
          onChange={setEndDate}
          minDate={startDate}
          shouldDisableDate={isDateAfterTodayOrBeforeJuneOfLastYear}
        />
      </Flex.Row>

      <Flex justifyContent="end">
        <Button
          size="md"
          label="Gerar Relatório"
          onClick={handleGenerateReport}
          disabled={!startDate || !endDate || hasInvalidDateRange}
        />
      </Flex>
    </form>
  );
};

export default withAuth(ManagementReport);
